import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";

import { PublicProtectionProfile } from "api/public/protectionProfiles/protectionProfiles.types";

import { getStatusInfo } from "../../utils/statusControl";

interface PpCardProps {
  card: PublicProtectionProfile;
}

export default function PpCard({ card }: PpCardProps) {
  const { statusColor, statusLabel } = getStatusInfo(card.sunset_date);

  return (
    <Card
      elevation={3}
      sx={{
        backgroundColor: "#f8f9fa",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          backgroundColor: statusColor,
          color: "white",
          textAlign: "center",
          textTransform: "uppercase",
          py: 0.5,
          fontWeight: "bold",
        }}
      >
        {statusLabel}
      </Box>
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" fontWeight="bold" px={1} mb={2}>
          {card.pp_name}
        </Typography>

        <Box display="flex" px={1} my={2}>
          <Stack flex={1}>
            <Typography variant="body2" sx={{ textDecoration: "underline" }}>
              Short Name
            </Typography>
            <Link to={`/protectionprofiles/${card.pp_id}`}>
              <Typography fontWeight="bold" color="primary">
                {card.pp_short_name}
              </Typography>
            </Link>
          </Stack>
          <Stack flex={1}>
            <Typography variant="body2" sx={{ textDecoration: "underline" }}>
              Technology Type
            </Typography>
            <Typography fontWeight="bold">{card.tech_type}</Typography>
          </Stack>
        </Box>

        <Box display="flex" px={1} my={2}>
          {card?.pp_date && (
            <Stack flex={1}>
              <Typography variant="body2" sx={{ textDecoration: "underline" }}>
                Approval Date
              </Typography>
              <Typography fontWeight="bold">
                {moment.utc(card.pp_date).format("MM/DD/YYYY")}
              </Typography>
            </Stack>
          )}
          <Stack flex={1}>
            <Typography variant="body2" sx={{ textDecoration: "underline" }}>
              CC Version
            </Typography>
            <Typography fontWeight="bold">{card.cc_version}</Typography>
          </Stack>
        </Box>

        <Box display="flex" px={1} my={2}>
          {card?.sunset_date && (
            <Stack flex={1}>
              <Typography variant="body2" sx={{ textDecoration: "underline" }}>
                Sunset Date
              </Typography>
              <Typography fontWeight="bold">
                {moment.utc(card.sunset_date).format("MM/DD/YYYY")}
              </Typography>
            </Stack>
          )}
          <Stack flex={1}>
            <Typography variant="body2" sx={{ textDecoration: "underline" }}>
              Sponsor
            </Typography>
            <Typography fontWeight="bold">{card.pp_sponsor_id}</Typography>
          </Stack>
        </Box>

        <Box display="flex" justifyContent="flex-end" px={1} mt="auto">
          <Button
            component={Link}
            to={`/protectionprofiles/${card.pp_id}`}
            variant="outlined"
            sx={{
              color: "text.primary",
              borderColor: "text.primary",
              "&:hover": {
                backgroundColor: "text.primary",
                borderColor: "text.primary",
                color: "background.paper",
              },
            }}
          >
            Full Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
